import IconCoursesPreview from '@assets/preview/appointment.webp';
import IconBlogPreview from '@assets/preview/blog.webp';
import IconCouponsPreview from '@assets/preview/coupons.webp';
import IconLinksPreview from '@assets/preview/links.webp';
import React from 'react';

import IconContentAppointment from '../assets/appointmentsСontent.svg';
import IconCardView from '../assets/design/cardView.svg';
import IconCompactView from '../assets/design/compactView.svg';
import IconEventsCardView from '../assets/design/events-view-card.svg';
import IconEventsCompactView from '../assets/design/events-view-compact.svg';
import IconEventsSquareView from '../assets/design/events-view-square.svg';
import IconListView from '../assets/design/listView.svg';
// import IconThemeDefault from '../assets/design/theme-default-preview.svg';
// import IconThemeEclipse from '../assets/design/theme-eclipse-preview.svg';
// import IconThemeKels from '../assets/design/theme-kels-preview.svg';
// import IconThemeMaterial from '../assets/design/theme-material-preview.svg';
// import IconThemeMinima from '../assets/design/theme-minima-preview.svg';
// import IconThemeModerno from '../assets/design/theme-moderno-preview.svg';
// import IconThemeNightview from '../assets/design/theme-nightview-preview.svg';
// import IconThemeSpotlight from '../assets/design/theme-spotlight-preview.svg';
// import IconThemeStone from '../assets/design/theme-stone-preview.svg';
// import IconThemeTyla from '../assets/design/theme-tyla-preview.svg';
import IconFondy from '../assets/fondyIcon.png';
import IconPayPal from '../assets/paypal.svg';
import IconAppointmentPreview from '../assets/preview/appointment.webp';
import IconDonationsPreview from '../assets/preview/donations.webp';
import IconInstagramPreview from '../assets/preview/instagramPreview.webp';
import IconRequestPreview from '../assets/preview/requests.webp';
import IconShopPreview from '../assets/preview/shop.webp';
import IconTikTokPreview from '../assets/preview/tiktok.webp';
import IconContentRequest from '../assets/requestSection.svg';
import IconContentDigital from '../assets/sections/digitalSection.svg';
import IconContentShop from '../assets/shop.svg';
import IconStripe from '../assets/stripe.svg';
import IconWayForPay from '../assets/wayforpay.png';
import { IconEditDraft, IconEditFailed, IconEditSent, IconEditSheduled } from '../components/design/Icons';
import { BaseUrl } from './httpClient';
import { sectionTypes } from './sectionEnums';

export const noPicture = 'https://unilink.us/content/profile_pic.jpg';
export const noProduct = 'https://unilink.us/content/noproduct.png';

export { EIntegrationTypes } from './integrationTypes';

export const AssistantCategory = {
  LocalBusiness: 'Local Business (local services)',
  RestaurantCafeFood: 'Restaurant / Cafe / Food',
  RetailEcommerce: 'Retail / Shop / E-commerce',
  BeautyWellnessFitness: 'Beauty / Wellness / Fitness',
  Healthcare: 'Healthcare',
  EducationTraining: 'Education / Training',
  ProfessionalServices: 'Professional Services (legal, accounting, consulting)',
  TechSoftwareIT: 'Tech / Software / IT',
  FinanceInsurance: 'Finance / Insurance',
  RealEstate: 'Real Estate',
  TravelHospitality: 'Travel / Hospitality',
  Automotive: 'Automotive',
  ArtsDesignCreativeStudio: 'Arts / Design / Creative Studio',
  CreatorInfluencerPublicFigure: 'Creator / Influencer / Public Figure',
  EntertainmentMedia: 'Entertainment / Media',
  NonprofitCommunityCause: 'Nonprofit / Community / Cause',
  OrganizationCompany: 'Organization / Company',
  Other: 'Other',
};

export const EWizardSteps = {
  INTEGRATIONS: 1,
  CAMPAIGN: 2,
  POST: 3,
  PUBLISH: 4,
  RESULT: 5,
};

export const heroTypes = {
  banner: 'Banner',
  popup: 'Popup',
  bannerPopup: 'Banner & Popup',
};

export const postDisplayTypes = {
  none: 'Just post',
  title: 'Title',
  titleDesc: 'Title, description',
  titleButton: 'Title, button',
  titleDescBtn: 'Title, description, button',
};

export const pricingDisplayTypes = {
  title: 'Title',
  titleDesc: 'Title, subtitle',
  titleButton: 'Title, button',
  titleDescBtn: 'Title, subtitle, button',
  titleDescBtnPrice: 'Title, subtitle, button, price',
  titleDescBtnPriceFeatures: 'Title, subtitle, button, price, description',
};

export const langTypes = {
  en: 'English',
  es: 'Spanish',
  pt: 'Portuguese',
  fr: 'French',
  de: 'German',
  it: 'Italian',
  tr: 'Turkish',
  ua: 'Українська',
  pl: 'Polski',
  zh: '中文',
  ja: '日本語',
  hu: 'Magyar',
};

export const currencyTypes = {
  USD: 'USD',
  EUR: 'EUR',
  GBP: 'GBP',
  UAH: 'UAH',
  RUB: 'RUB',
  AED: 'AED',
  BRL: 'BRL',
  INR: 'INR',
  CZK: 'CZK',
  PLN: 'PLN',
};

export const quantityTypes = {
  notSelected: 'Not selected',
  limited: 'Limited',
  availability: 'Availability',
};

export const customFormTypes = {
  none: 'None',
  email: 'Send an email',
  redirect: 'Redirect',
  download: 'Download file',
};

export const subscribeTypes = {
  email: 'email',
  instagram: 'instagram',
  messenger: 'messenger',
  phone: 'phone',
  telegram: 'telegram',
  whatsapp: 'whatsapp',
  viber: 'viber',
};

export const domainTypes = {
  default: 'unilink.us',
  shop: 'unil.shop',
  custom: 'your-domain.com',
};

export const initialPropertiesList = {
  title: '',
  type: 1,
  values: [],
};

export const initialPropertiesTypeOptions = [
  {
    value: 'String',
    label: 'String',
  },
  {
    value: 'Color',
    label: 'Color',
  },
];

export const chosenPropertiesTypeOptions = [
  {
    value: 'String',
    label: 'String',
  },
  {
    value: 'Color',
    label: 'Color',
  },
];

export const activeButtonTypes = {
  select: 'select',
  none: 'none',
  navigation: 'navigation',
  ctaButtons: 'URL',
  contacts: 'contacts',
  donations: 'donations',
  email: 'email',
  form: 'form',
  link: 'links',
  wallet: 'wallet',
  map: 'map',
  coupons: 'coupons',
  music: 'music',
  shop: 'shop',
  digital: 'digital',
  appointments: 'appointments',
  services: 'services',
  events: 'events',
  courses: 'courses',
};

export const messageDelayTypes = {
  instantly: 'Instantly',
  after: 'After 30 seconds',
  oneMinute: '1 minute',
  twoMinute: '2 minute',
};

export const messageFrequencyTypes = {
  once: 'Just once',
  every: 'Every time',
};

export const socialLinksItems = [
  {
    type: 1,
    title: 'Instagram',
    icon: 'instagram.svg',
    N: 2,
  },
  {
    type: 2,
    title: 'Twitter',
    icon: 'twitter.svg',
    N: 8,
  },
  {
    type: 3,
    title: 'Facebook',
    icon: 'facebook.svg',
    N: 3,
  },
  {
    type: 4,
    title: 'LinkedIn',
    icon: 'linkedin.svg',
    N: 6,
  },
  {
    type: 5,
    title: 'TikTok',
    icon: 'tiktok.svg',
    N: 4,
  },
  {
    type: 6,
    title: 'Snapchat',
    icon: 'snapchat.svg',
    N: 22,
  },
  {
    type: 7,
    title: 'Patreon',
    icon: 'patreon.svg',
    N: 20,
  },
  {
    type: 8,
    title: 'Pinterest',
    icon: 'pinterest.svg',
    N: 25,
  },
  {
    type: 9,
    title: 'YouTube',
    icon: 'youtube.svg',
    N: 5,
  },
  {
    type: 10,
    title: 'Vimeo',
    icon: 'vimeo.svg',
    N: 18,
  },
  {
    type: 11,
    title: 'Twitch',
    icon: 'twitch.svg',
    N: 19,
  },
  {
    type: 12,
    title: 'Behance',
    icon: 'behance.svg',
    N: 23,
  },
  {
    type: 13,
    title: 'Dribbble',
    icon: 'dribbble.svg',
    N: 24,
  },
  {
    type: 14,
    title: 'Apple Music',
    icon: 'applemusic.svg',
    N: 30,
  },
  {
    type: 15,
    title: 'Apple Podcast',
    icon: 'applepodcasts.svg',
    N: 31,
  },
  {
    type: 16,
    title: 'Spotify',
    icon: 'spotify.svg',
    N: 34,
  },
  {
    type: 17,
    title: 'Bandcamp',
    icon: 'bandcamp.svg',
    N: 35,
  },
  {
    type: 18,
    title: 'SoundCloud',
    icon: 'soundcloud.svg',
    N: 36,
  },
  {
    type: 19,
    title: 'Tidal',
    icon: 'tidal.svg',
    N: 39,
  },
  {
    type: 20,
    title: 'Slack',
    icon: 'slack.svg',
    N: 16,
  },
  {
    type: 21,
    title: 'Discord',
    icon: 'discord.svg',
    N: 33,
  },
  // {
  //   type: 22,
  //   title: 'VK',
  //   icon: 'vk.svg',
  //   N: 57,
  // },
  // {
  //   type: 23,
  //   title: 'Yandex Zen',
  //   icon: 'yandexzen.svg',
  //   N: 58,
  // },
  {
    type: 24,
    title: 'Telegram',
    icon: 'telegram.svg',
    N: 12,
  },
  {
    type: 26,
    title: 'Signal',
    icon: 'signal.svg',
    N: 37,
  },
  {
    type: 27,
    title: 'ProductHunt',
    icon: 'producthunt.svg',
    N: 38,
  },
  {
    type: 28,
    title: 'Cameo',
    icon: 'cameo.svg',
    N: 40,
  },
  {
    type: 29,
    title: 'Amazon',
    icon: 'amazon.svg',
    N: 41,
  },
  {
    type: 30,
    title: 'Google Play',
    icon: 'googleplay.svg',
    N: 28,
  },
  {
    type: 32,
    title: 'Apple Store',
    icon: 'applestore.svg',
    N: 29,
  },
  {
    type: 33,
    title: 'Medium',
    icon: 'medium.svg',
    N: 32,
  },
  {
    type: 34,
    title: 'Buymeacoffee',
    icon: 'buymeacoffee.svg',
    N: 42,
  },
  {
    type: 35,
    title: 'Reddit',
    icon: 'reddit.svg',
    N: 43,
  },
  {
    type: 36,
    title: 'GoodReads',
    icon: 'goodreads.svg',
    N: 44,
  },
  {
    type: 37,
    title: 'GitHub',
    icon: 'github.svg',
    N: 45,
  },
  {
    type: 38,
    title: 'Poshmark',
    icon: 'poshmark.svg',
    N: 46,
  },
  {
    type: 39,
    title: 'Beatport',
    icon: 'beatport.svg',
    N: 47,
  },
  {
    type: 40,
    title: 'DeviantArt',
    icon: 'deviantart.svg',
    N: 48,
  },
  {
    type: 41,
    title: 'Game Jolt',
    icon: 'gamejolt.svg',
    N: 49,
  },
  {
    type: 42,
    title: 'itch.io',
    icon: 'itchio.svg',
    N: 50,
  },
  {
    type: 43,
    title: 'Last.fm',
    icon: 'lastfm.svg',
    N: 51,
  },
  {
    type: 44,
    title: 'Mastodon',
    icon: 'mastodon.svg',
    N: 52,
  },
  {
    type: 45,
    title: 'Newgrounds',
    icon: 'newgrounds.svg',
    N: 53,
  },
  {
    type: 46,
    title: 'PayPal',
    icon: 'paypal.svg',
    N: 17,
  },
  {
    type: 47,
    title: 'Quora',
    icon: 'quora.svg',
    N: 27,
  },
  {
    type: 48,
    title: 'Throne',
    icon: 'throne.svg',
    N: 54,
  },
  {
    type: 49,
    title: 'Thumblr',
    icon: 'thumblr.svg',
    N: 55,
  },
  {
    type: 50,
    title: 'Xbox',
    icon: 'xbox.svg',
    N: 56,
  },
  {
    type: 51,
    title: 'Website',
    icon: 'website.svg',
    N: 1,
  },
  {
    type: 52,
    title: 'Upwork',
    icon: 'upwork.svg',
    N: 26,
  },
  {
    type: 53,
    title: 'Email',
    icon: 'email.svg',
    N: 10,
  },
  {
    type: 54,
    title: 'WhatsApp',
    icon: 'whatsapp.svg',
    N: 13,
  },
  {
    type: 55,
    title: 'Viber',
    icon: 'viber.svg',
    N: 15,
  },
  {
    type: 56,
    title: 'Messenger',
    icon: 'messenger.svg',
    N: 14,
  },
  {
    type: 57,
    title: 'Phone',
    icon: 'phone.svg',
    N: 11,
  },
  {
    type: 58,
    title: 'Threads',
    icon: 'threads.svg',
    N: 7,
  },
  {
    type: 59,
    title: 'X',
    icon: 'x.svg',
    N: 9,
  },
  {
    type: 60,
    title: 'OnlyFans',
    icon: 'onlyfans.svg',
    N: 21,
  },
  {
    type: 61,
    title: 'BeReal',
    icon: 'bereal.svg',
    N: 57,
  },
  {
    type: 62,
    title: 'Bluesky',
    icon: 'bluesky.svg',
    N: 58,
  },
  {
    type: 63,
    title: 'Clubhouse',
    icon: 'clubhouse.svg',
    N: 59,
  },
  {
    type: 64,
    title: 'Etsy',
    icon: 'etsy.svg',
    N: 60,
  },
  {
    type: 65,
    title: 'Kick',
    icon: 'kick.svg',
    N: 61,
  },
  {
    type: 66,
    title: 'Substack',
    icon: 'substack.svg',
    N: 62,
  },
  {
    type: 67,
    title: 'Payment',
    icon: 'payment.svg',
    N: 63,
  },
  {
    type: 68,
    title: 'Amazon Music',
    icon: 'amazonmusic.svg',
    N: 64,
  },
  {
    type: 69,
    title: 'Bandsintown',
    icon: 'bandsintown.svg',
    N: 65,
  },
  {
    type: 70,
    title: 'Deezer',
    icon: 'deezer.svg',
    N: 66,
  },
];

// export const socialLinksItems = [
//   {
//     type: 51,
//     title: 'Website',
//     icon: 'website.svg',
//     N: 1,
//   },
//   {
//     type: 1,
//     title: 'Instagram',
//     icon: 'instagram.svg',
//     N: 2,
//   },
//   {
//     type: 3,
//     title: 'Facebook',
//     icon: 'facebook.svg',
//     N: 3,
//   },
//   {
//     type: 5,
//     title: 'TikTok',
//     icon: 'tiktok.svg',
//     N: 4,
//   },
//   {
//     type: 9,
//     title: 'YouTube',
//     icon: 'youtube.svg',
//     N: 5,
//   },
//   {
//     type: 4,
//     title: 'LinkedIn',
//     icon: 'linkedin.svg',
//     N: 6,
//   },
//   {
//     type: 58,
//     title: 'Threads',
//     icon: 'threads.svg',
//     N: 7,
//   },
//   {
//     type: 2,
//     title: 'Twitter',
//     icon: 'twitter.svg',
//     N: 8,
//   },
//   {
//     type: 59,
//     title: 'X',
//     icon: 'x.svg',
//     N: 9,
//   },
//   {
//     type: 53,
//     title: 'Email',
//     icon: 'email.svg',
//     N: 10,
//   },
//   {
//     type: 57,
//     title: 'Phone',
//     icon: 'phone.svg',
//     N: 11,
//   },
//   {
//     type: 24,
//     title: 'Telegram',
//     icon: 'telegram.svg',
//     N: 12,
//   },
//   {
//     type: 54,
//     title: 'WhatsApp',
//     icon: 'whatsapp.svg',
//     N: 13,
//   },
//   {
//     type: 56,
//     title: 'Messenger',
//     icon: 'messenger.svg',
//     N: 14,
//   },
//   {
//     type: 55,
//     title: 'Viber',
//     icon: 'viber.svg',
//     N: 15,
//   },
//   {
//     type: 20,
//     title: 'Slack',
//     icon: 'slack.svg',
//     N: 16,
//   },
//   {
//     type: 46,
//     title: 'PayPal',
//     icon: 'paypal.svg',
//     N: 17,
//   },
//   {
//     type: 10,
//     title: 'Vimeo',
//     icon: 'vimeo.svg',
//     N: 18,
//   },
//   {
//     type: 11,
//     title: 'Twitch',
//     icon: 'twitch.svg',
//     N: 19,
//   },
//   {
//     type: 7,
//     title: 'Patreon',
//     icon: 'patreon.svg',
//     N: 20,
//   },
//   {
//     type: 60,
//     title: 'OnlyFans',
//     icon: 'onlyfans.svg',
//     N: 21,
//   },
//   {
//     type: 6,
//     title: 'Snapchat',
//     icon: 'snapchat.svg',
//     N: 22,
//   },
//   {
//     type: 12,
//     title: 'Behance',
//     icon: 'behance.svg',
//     N: 23,
//   },
//   {
//     type: 13,
//     title: 'Dribble',
//     icon: 'dribble.svg',
//     N: 24,
//   },
//   {
//     type: 8,
//     title: 'Pinterest',
//     icon: 'pinterest.svg',
//     N: 25,
//   },
//   {
//     type: 52,
//     title: 'Upwork',
//     icon: 'upwork.svg',
//     N: 26,
//   },
//   {
//     type: 47,
//     title: 'Quora',
//     icon: 'quora.svg',
//     N: 27,
//   },
//   {
//     type: 30,
//     title: 'Google Play',
//     icon: 'googleplay.svg',
//     N: 28,
//   },
//   {
//     type: 32,
//     title: 'Apple Store',
//     icon: 'applestore.svg',
//     N: 29,
//   },
//   {
//     type: 14,
//     title: 'Apple Music',
//     icon: 'applemusic.svg',
//     N: 30,
//   },
//   {
//     type: 15,
//     title: 'Apple Podcast',
//     icon: 'applepodcasts.svg',
//     N: 31,
//   },
//   {
//     type: 33,
//     title: 'Medium',
//     icon: 'medium.svg',
//     N: 32,
//   },
//   {
//     type: 21,
//     title: 'Discord',
//     icon: 'discord.svg',
//     N: 33,
//   },
//   {
//     type: 16,
//     title: 'Spotify',
//     icon: 'spotify.svg',
//     N: 34,
//   },
//   {
//     type: 17,
//     title: 'Bandcamp',
//     icon: 'bandcamp.svg',
//     N: 35,
//   },
//   {
//     type: 18,
//     title: 'SoundCloud',
//     icon: 'soundcloud.svg',
//     N: 36,
//   },
//   {
//     type: 26,
//     title: 'Signal',
//     icon: 'signal.svg',
//     N: 37,
//   },
//   {
//     type: 27,
//     title: 'ProductHunt',
//     icon: 'producthunt.svg',
//     N: 38,
//   },
//   {
//     type: 19,
//     title: 'Tidal',
//     icon: 'tidal.svg',
//     N: 39,
//   },
//   {
//     type: 28,
//     title: 'Cameo',
//     icon: 'cameo.svg',
//     N: 40,
//   },
//   {
//     type: 29,
//     title: 'Amazon',
//     icon: 'amazon.svg',
//     N: 41,
//   },
//   {
//     type: 34,
//     title: 'Buymeacoffee',
//     icon: 'buymeacoffee.svg',
//     N: 42,
//   },
//   {
//     type: 35,
//     title: 'Reddit',
//     icon: 'reddit.svg',
//     N: 43,
//   },
//   {
//     type: 36,
//     title: 'GoodReads',
//     icon: 'goodreads.svg',
//     N: 44,
//   },
//   {
//     type: 37,
//     title: 'GitHub',
//     icon: 'github.svg',
//     N: 45,
//   },
//   {
//     type: 38,
//     title: 'Poshmark',
//     icon: 'poshmark.svg',
//     N: 46,
//   },
//   {
//     type: 39,
//     title: 'Beatport',
//     icon: 'beatport.svg',
//     N: 47,
//   },
//   {
//     type: 40,
//     title: 'DeviantArt',
//     icon: 'deviantart.svg',
//     N: 48,
//   },
//   {
//     type: 41,
//     title: 'Game Jolt',
//     icon: 'gamejolt.svg',
//     N: 49,
//   },
//   {
//     type: 42,
//     title: 'itch.io',
//     icon: 'itchio.svg',
//     N: 50,
//   },
//   {
//     type: 43,
//     title: 'Last.fm',
//     icon: 'lastfm.svg',
//     N: 51,
//   },
//   {
//     type: 44,
//     title: 'Mastodon',
//     icon: 'mastodon.svg',
//     N: 52,
//   },
//   {
//     type: 45,
//     title: 'Newgrounds',
//     icon: 'newgrounds.svg',
//     N: 53,
//   },
//   {
//     type: 48,
//     title: 'Throne',
//     icon: 'throne.svg',
//     N: 54,
//   },
//   {
//     type: 49,
//     title: 'Thumblr',
//     icon: 'thumblr.svg',
//     N: 55,
//   },
//   {
//     type: 50,
//     title: 'Xbox',
//     icon: 'xbox.svg',
//     N: 56,
//   },
// ];

export const directIconItems = [
  {
    type: 2,
    title: 'Messenger',
    icon: 'messenger.svg',
  },
  {
    type: 3,
    title: 'WhatsApp',
    icon: 'whatsapp.svg',
  },
  {
    type: 4,
    title: 'Viber',
    icon: 'viber.svg',
  },
  {
    type: 5,
    title: 'Telegram',
    icon: 'telegram.svg',
  },
  {
    type: 6,
    title: 'Phone',
    icon: 'phone.svg',
  },
  {
    type: 7,
    title: 'Email',
    icon: 'email.svg',
  },
  {
    type: 8,
    title: 'Instagram',
    icon: 'instagram.svg',
  },
];
export const subpageUploadVideoTypes = {
  insert: 'Insert URL',
  upload: 'Upload video',
};

export const backgroundUploadVideoTypes = {
  insert: 'insert',
  upload: 'upload',
  search: 'search',
};

export const pickerColors = [
  '#000000',
  '#555',
  '#a4aaa0',
  '#dddddd',
  '#ffffff',
  '#efb5c1',
  '#ff91bb',
  '#fe68a8',
  '#fe3c71',
  '#ff2154',
  '#c86d4e',
  '#f5865b',
  '#d9bd8e',
  '#d1b284',
  '#b3816a',
  '#2bd666',
  '#afdabe',
  '#6ababb',
  '#4bc6d6',
  '#0082fe',
  '#4299e0',
  '#4e9fbc',
  '#3a68ca',
  '#9bb1c9',
  '#ffd95c',
  '#f8ca37',
  '#f9ab3f',
  '#a92ea3',
  '#e018c1',
  '#cb7cd8',
];

export const animationOptions = [
  {
    value: 'none',
    label: 'none',
  },
  {
    value: 'pulse',
    label: 'pulse',
  },
  {
    value: 'shake',
    label: 'shake',
  },
  {
    value: 'tada',
    label: 'tada',
  },
  {
    value: 'bounceIn',
    label: 'bounceIn',
  },
  {
    value: 'fadeIn',
    label: 'fadeIn',
  },
  {
    value: 'flipInX',
    label: 'flipInX',
  },
  {
    value: 'flipInY',
    label: 'flipInY',
  },
  {
    value: 'zoomIn',
    label: 'zoomIn',
  },
  {
    value: 'swing',
    label: 'swing',
  },
  {
    value: 'jello',
    label: 'jello',
  },
];

export const buttonLinkUrlType = {
  link: 'Link',
  phone: 'Phone',
  viber: 'Viber',
  skype: 'Skype',
  email: 'Email',
  post: 'Post',
  page: 'Page',
  document: 'Document',
};

export const linkDesignTypes = {
  button: 'button',
  round: 'round',
  square: 'square',
  full: 'full',
  cover: 'cover',
  card: 'card',
  ticket: 'ticket',
};

export const eventsDesignTypes = {
  square: 'squareEvents',
  compact: 'compact',
  ticket: 'ticket',
};

export const buttonLinkUrlCaptions = {
  link: 'Link',
  phone: 'Phone Call',
  viber: 'Open Viber',
  skype: 'Open Skype',
  email: 'Send Email',
  post: 'Post',
  page: 'Page',
  document: 'Document',
};

export const donationItems = [
  {
    id: 1,
    title: 'Coffee',
    icon: '☕',
  },
  {
    id: 2,
    title: 'Beer',
    icon: '🍺',
  },
  {
    id: 3,
    title: 'Pizza',
    icon: '🍕',
  },
  {
    id: 4,
    title: 'Book',
    icon: '📖',
  },
  {
    id: 5,
    title: 'Ukraine',
    icon: 'ua',
  },
  {
    id: 6,
    title: 'Tea',
    icon: '🍵',
  },
  {
    id: 7,
    title: 'Cake',
    icon: '🍰',
  },
  {
    id: 8,
    title: 'Donut',
    icon: '🍩',
  },
  {
    id: 9,
    title: 'Burger',
    icon: '🍔',
  },
  {
    id: 10,
    title: 'Taco',
    icon: '🌮',
  },
  {
    id: 11,
    title: 'Ice cream',
    icon: '🍦',
  },
  {
    id: 12,
    title: 'Wine',
    icon: '🍷',
  },
  {
    id: 13,
    title: 'Cocktail',
    icon: '🍸',
  },
  {
    id: 14,
    title: 'Flower',
    icon: '🌸',
  },
  {
    id: 15,
    title: 'Heart',
    icon: '❤️',
  },
  {
    id: 16,
    title: 'Gift',
    icon: '🎁',
  },
  {
    id: 17,
    title: 'Star',
    icon: '⭐',
  },
  {
    id: 18,
    title: 'Fuel',
    icon: '⛽',
  },
  {
    id: 19,
    title: 'Music',
    icon: '🎵',
  },
  {
    id: 20,
    title: 'Game',
    icon: '🎮',
  },
];

export const contactList = [
  {
    id: 1,
    title: 'Facebook Messenger',
    icon: 'facebook-messenger.png',
    backgroundColor: '#0084FF',
    placeholder: '@pagename or https://facebook.com/pagename ',
    regex: 'http://m.me/page_name',
  },
  { id: 2, title: 'WhatsApp', icon: 'whatsapp.png', backgroundColor: '#55CD6C', placeholder: '+15551234567', regex: 'https://wa.me/15551234567' },
  { id: 3, title: 'Viber', icon: 'viber.png', backgroundColor: '#7C529D', placeholder: '+15551234567', regex: 'viber://chat?number=15551234567' },
  { id: 5, title: 'Telegram', icon: 'telegram.png', backgroundColor: '#27A6E6', placeholder: '@username or https://t.me/username', regex: 'https://t.me/username' },
  { id: 6, title: 'Twitter', icon: 'twitter.png', backgroundColor: '#1DA1F2', placeholder: '@username or https://twitter.com/username', regex: 'https://twitter.com/username' },
  { id: 7, title: 'Phone', icon: 'phone.png', backgroundColor: '#52C745', placeholder: '+4917640206387', regex: 'tel:+4917640206387' },
  { id: 8, title: 'Email', icon: 'email.png', backgroundColor: '#61A5FF', placeholder: 'example@gmail.com', regex: 'mailto:example@gmail.com' },
  {
    id: 9,
    title: 'Location',
    icon: 'location.png',
    backgroundColor: '#FF151E',
    placeholder: 'https://goo.gl/maps/xRinfSPLHSahD7GQ7',
    regex: 'https://goo.gl/maps/xRinfSPLHSahD7GQ7',
  },
  { id: 10, title: 'Instagram', icon: 'instagram.png ', backgroundColor: '#D2337A', placeholder: '@username or https://instagram.com/username', regex: 'https://ig.me/m/username' },
  { id: 11, title: 'Skype', icon: 'skype.png', backgroundColor: '#00AFF0', placeholder: '@username or https://skype.com/username', regex: 'https://username' },
];

export const fontsTypes = {
  plusJacarta: 'Plus Jakarta Sans',
  notoSerifDisplay: 'Noto Serif Display',
  nunitoSans: 'Nunito Sans',
  montserrat: 'Montserrat',
  roboto: 'Roboto',
  raleway: 'Raleway',
  openSans: 'Open Sans',
  notoSans: 'Noto Sans',
  lato: 'Lato',
  poppins: 'Poppins',
  sourceSansPro: 'Source Sans Pro',
  ptSans: 'PT Sans',
  robotoCondensed: 'Roboto Condensed',
  oswald: 'Oswald',
  robotoMono: 'Roboto Mono',
  ubuntu: 'Ubuntu',
  inter: 'Inter',
  nunito: 'Nunito',
  robotoSlab: 'Roboto Slab',
  // Catalogue expansion. Loading is dynamic — Unilink builds one Google Fonts request from the
  // selected family names (see src/components/Unilink/index.js), so a new family needs no other
  // registration. "Expand the available font options, probably by integrating google fonts" is one of
  // the most-liked requests on competing products.
  dmSans: 'DM Sans',
  dmSerifDisplay: 'DM Serif Display',
  workSans: 'Work Sans',
  figtree: 'Figtree',
  manrope: 'Manrope',
  outfit: 'Outfit',
  spaceGrotesk: 'Space Grotesk',
  sora: 'Sora',
  urbanist: 'Urbanist',
  publicSans: 'Public Sans',
  rubik: 'Rubik',
  karla: 'Karla',
  mulish: 'Mulish',
  quicksand: 'Quicksand',
  josefinSans: 'Josefin Sans',
  bebasNeue: 'Bebas Neue',
  anton: 'Anton',
  archivo: 'Archivo',
  archivoBlack: 'Archivo Black',
  playfairDisplay: 'Playfair Display',
  merriweather: 'Merriweather',
  loraSerif: 'Lora',
  cormorantGaramond: 'Cormorant Garamond',
  libreBaskerville: 'Libre Baskerville',
  crimsonPro: 'Crimson Pro',
  ebGaramond: 'EB Garamond',
  bitter: 'Bitter',
  spaceMono: 'Space Mono',
  jetBrainsMono: 'JetBrains Mono',
  ibmPlexSans: 'IBM Plex Sans',
  ibmPlexMono: 'IBM Plex Mono',
  fira: 'Fira Sans',
  // Handwritten / script fonts — for decorative accent phrases.
  caveat: 'Caveat',
  dancingScript: 'Dancing Script',
  greatVibes: 'Great Vibes',
  pacifico: 'Pacifico',
  sacramento: 'Sacramento',
};

export const musicTypes = {
  url: 'url',
  embedCode: 'embed code',
  custom: 'custom',
};

export const chooseColorList = {
  blue: '#5f7fff',
  purple: '#bd5fff',
  red: '#ff5f5f',
  green: '#79d6b5',
  black: '#000000',
  darkBlue: '#3a3964',
  orange: '#ffaf47',
};
export const shopProductTypes = {
  fullPage: 'Full page',
  tags: 'Tags',
  redirect: 'Redirect',
};

export const productMenuTypes = {
  details: 'Product details',
  preview: 'Product preview',
  settings: 'Settings',
  heading: 'Heading',
  links: 'Links',
  modal: 'Modal',
  design: 'Design',
};

export const shopProductNumberTypes = {
  fullPage: 2,
  tags: 3,
  redirect: 1,
};

export const backgroundColorsList = [
  [
    '#7CDFF2',
    '#B3F7EF',
    '#EFF7F6',
    '#F7D6E0',
    '#F2B6D4',
    '#FCF9DA',
    '#E0EBF7',
    '#D3EDDB',
    '#F9D7F6',
    '#FCDFD7',
    '#E6CAE1',
    '#F4DCB2',
    '#7A87CB',
    '#B0D7F7',
    '#C9B5E1',
    '#D2D0F5',
    '#D7C7D8',
    '#F2E7F8',
    '#C1B7FF',
    '#FAF7FB',
    '#A9D1E7',
    '#B4DBD8',
    '#E2F1F0',
    '#FEE5E0',
    '#D7EDD5',
    '#E0D9C4',
    '#A6C9D1',
    '#FEDDD5',
    '#DDF1F0',
    '#FFC0C6',
  ],
  [
    '#797886',
    '#DEB8B9',
    '#F2D5D7',
    '#FDEBEB',
    '#F6F2F1',
    '#FEDCD5',
    '#E4EFF0',
    '#FFD2D3',
    '#F89191',
    '#FDFEF3',
    '#F3F2F3',
    '#CBEDEE',
    '#FFC5A0',
    '#F4A096',
    '#C6A6B1',
    '#F5B0A5',
    '#CAC7E1',
    '#FFE7E5',
    '#03AFBA',
    '#D7D7D6',
    '#83A4AD',
    '#AAC8C6',
    '#C0D8D2',
    '#E2CFCA',
    '#96BDCD',
    '#FCDCDC',
    '#2D4E5B',
    '#998181',
    '#BFCEDA',
    '#D1ADA6',
  ],
  [
    '#EDEEF3',
    '#F5DDE0',
    '#EABFC4',
    '#DD878D',
    '#D0657D',
    '#B74276',
    '#D0B2C7',
    '#9D5E7D',
    '#505050',
    '#FC8D95',
    '#FBCCCC',
    '#F9C4D7',
    '#ECF8F8',
    '#EEE4E1',
    '#E7D8CA',
    '#E6BFAF',
    '#B3977E',
    '#E8CB9F',
    '#FAC686',
    '#F6BE62',
    '#F7EDE2',
    '#F5CBC4',
    '#85A69E',
    '#F28583',
    '#FFE495',
    '#FDC4BF',
    '#FE7C74',
    '#04909D',
    '#E4DCCF',
    '#E0B5A5',
  ],
  [
    '#031B89',
    '#6196FF',
    '#A9B5FF',
    '#FB7A8E',
    '#FAA7B7',
    '#FEC195',
    '#B088CE',
    '#EA1D80',
    '#FEC706',
    '#A9F388',
    '#19D6FA',
    '#53DBFF',
    '#FAD6EB',
    '#A55EBA',
    '#A55EBA',
    '#FF6182',
    '#03ECC3',
    '#0379FF',
    '#8AC8CC',
    '#F4F4B5',
    '#FDAF87',
    '#FFD761',
    '#FF8B27',
    '#FF455B',
    '#7473C2',
    '#0CA5DB',
    '#FBC859',
    '#F64E34',
    '#5E0D99',
    '#071F46',
  ],
  [
    '#2D3B58',
    '#4D7397',
    '#B0D0DB',
    '#3F425D',
    '#82B39B',
    '#F2CC90',
    '#C57732',
    '#FAC686',
    '#086B7D',
    '#6AA8AD',
    '#C7A98E',
    '#F4F1DE',
    '#DFE669',
    '#4F627C',
    '#9E4050',
    '#EE6B67',
    '#FF8D66',
    '#56C3CD',
    '#F8BBA8',
    '#E2896B',
    '#E69681',
    '#FFA881',
    '#FF7D54',
    '#FFE5D2',
    '#2D316E',
    '#58497A',
    '#9E6E83',
    '#C2808C',
    '#DE9890',
    '#DCA8A4',
  ],
  [
    '#091D26',
    '#A7ABEE',
    '#3D467B',
    '#242D61',
    '#D9D9D9',
    '#052168',
    '#2C275E',
    '#375AAF',
    '#C8AAD4',
    '#0FA8B8',
    '#F96C94',
    '#F96C94',
    '#033A37',
    '#78B4B9',
    '#C1CECF',
    '#6B8599',
    '#D2BFC2',
    '#84759F',
    '#22545E',
    '#211B2A',
    '#233705',
    '#580B58',
    '#A9117A',
    '#2F034A',
    '#130D6F',
    '#5E72EB',
    '#760651',
    '#4D0128',
    '#1B1B41',
    '#403452',
  ],
];

export const backgroundGradientsList = [
  [
    { color1: '#a529b9', color2: '#50b1e1', gradient: 'linear-gradient(111.7deg, #a529b9 19.9%, #50b1e1 95%)' },
    { color1: '#ffb418', color2: '#f73131', gradient: 'linear-gradient(109.6deg, #ffb418 11.2%, #f73131 91.1%)' },
    { color1: '#79F1A4', color2: '#0E5CAD', gradient: 'linear-gradient(135deg, #79F1A4 10%, #0E5CAD 100%)' },
    { color1: '#ff758c', color2: '#ff7eb3', gradient: 'linear-gradient(to bottom, #ff758c, #ff7eb3)' },
    { color1: '#3355ff', color2: '#0088ff', gradient: 'linear-gradient(292.2deg, #3355ff 33.7%, #0088ff 93.7%)' },
    { color1: '#191654', color2: '#43C6AC', gradient: 'linear-gradient(to bottom, #191654, #43C6AC)' },

    { color1: '#DA4453', color2: '#89216B', gradient: 'linear-gradient(to bottom, #DA4453, #89216B)' },
    { color1: '#6A82FB', color2: '#FC5C7D', gradient: 'linear-gradient(to bottom, #6A82FB, #FC5C7D)' },
    { color1: '#ff5e62', color2: '#ff9966', gradient: 'linear-gradient(to bottom, #ff5e62, #ff9966)' },
    { color1: '#0575E6', color2: '#00F260', gradient: 'linear-gradient(to bottom, #0575E6, #00F260)' },
    { color1: '#FF0099', color2: '#493240', gradient: 'linear-gradient(to bottom, #FF0099, #493240)' },
    { color1: '#F37335', color2: '#FDC830', gradient: 'linear-gradient(to bottom, #F37335, #FDC830)' },

    { color1: '#0057b7', color2: '#ffd700', gradient: 'linear-gradient(to bottom, #0057b7 40%, #ffd700 80%)' },
    { color1: '#9796f0', color2: '#fbc7d4', gradient: 'linear-gradient(to bottom, #9796f0, #fbc7d4)' },
    { color1: '#D6ECDE', color2: '#F7D8F5', gradient: 'linear-gradient(to bottom, #D6ECDE, #F7D8F5)' },
    { color1: '#F9D7F3', color2: '#FCDED9', gradient: 'linear-gradient(to bottom, #F9D7F3, #FCDED9)' },
    { color1: '#996A82', color2: '#5C4A7A', gradient: 'linear-gradient(to bottom, #996A82, #5C4A7A)' },
    { color1: '#CAABD4', color2: '#F6C1D7', gradient: 'linear-gradient(to bottom, #CAABD4, #F6C1D7)' },

    { color1: '#B1D5F6', color2: '#C8B6E2', gradient: 'linear-gradient(to bottom, #B1D5F6, #C8B6E2)' },
    { color1: '#B8EB6F', color2: '#EDCF1E', gradient: 'linear-gradient(to bottom, #B8EB6F, #EDCF1E)' },
    { color1: '#32DBE3', color2: '#91EE98', gradient: 'linear-gradient(to bottom, #32DBE3, #91EE98)' },
    { color1: '#a750bb', color2: '#112968', gradient: 'linear-gradient(to bottom, #a750bb, #112968)' },
    { color1: '#9495D6', color2: '#33C7F2', gradient: 'linear-gradient(to bottom, #9495D6, #33C7F2)' },
    {
      color1: '#1A73E8',
      color2: '#34A853',
      gradient: 'linear-gradient(to bottom, #1A73E8, #34A853)',
    },

    { color1: '#DF2F8E', color2: '#B875C1', gradient: 'linear-gradient(to bottom, #DF2F8E, #B875C1)' },
    { color1: '#E1B8A8', color2: '#E3D5C8', gradient: 'linear-gradient(to bottom, #E1B8A8, #E3D5C8)' },
    { color1: '#ECD6B4', color2: '#828DC9', gradient: 'linear-gradient(to bottom, #ECD6B4, #828DC9)' },
    { color1: '#EE6E95', color2: '#1DA5B6', gradient: 'linear-gradient(to bottom, #EE6E95, #1DA5B6)' },
    { color1: '#49A3C1', color2: '#98E1F0', gradient: 'linear-gradient(to bottom, #49A3C1, #98E1F0)' },
    { color1: '#E6A620', color2: '#1A4959', gradient: 'linear-gradient(to bottom, #E6A620, #1A4959)' },
  ],
  [
    { color1: '#F28410', color2: '#F7AA1B', gradient: 'linear-gradient(to bottom, #F28410, #F7AA1B)' },
    { color1: '#F4DADB', color2: '#9CBFCD', gradient: 'linear-gradient(to bottom, #F4DADB, #9CBFCD)' },
    { color1: '#385562', color2: '#F7D9DA', gradient: 'linear-gradient(to bottom, #385562, #F7D9DA)' },
    { color1: '#F6E195', color2: '#10959E', gradient: 'linear-gradient(to bottom, #F6E195, #10959E)' },
    { color1: '#FDC6BC', color2: '#FFE397', gradient: 'linear-gradient(to bottom, #FDC6BC, #FFE397)' },
    { color1: '#7F759F', color2: '#0C8E9D', gradient: 'linear-gradient(to bottom, #7F759F, #0C8E9D)' },

    { color1: '#F5C15B', color2: '#601099', gradient: 'linear-gradient(to bottom, #F5C15B, #601099)' },
    { color1: '#640F96', color2: '#F14C38', gradient: 'linear-gradient(to bottom, #640F96, #F14C38)' },
    { color1: '#0B97CC', color2: '#082F59', gradient: 'linear-gradient(to bottom, #0B97CC, #082F59)' },
    { color1: '#0C7DF9', color2: '#F7D466', gradient: 'linear-gradient(to bottom, #0C7DF9, #F7D466)' },
    { color1: '#F44D60', color2: '#0BE7C0', gradient: 'linear-gradient(to bottom, #F44D60, #0BE7C0)' },
    { color1: '#03E7C5', color2: '#037EFD', gradient: 'linear-gradient(to bottom, #03E7C5, #037EFD)' },

    { color1: '#ECF0B6', color2: '#8FCACB', gradient: 'linear-gradient(to bottom, #ECF0B6, #8FCACB)' },
    { color1: '#E02F8E', color2: '#B977C2', gradient: 'linear-gradient(to bottom, #E02F8E, #B977C2)' },
    { color1: '#31DBE7', color2: '#91EE9C', gradient: 'linear-gradient(to bottom, #31DBE7, #91EE9C)' },
    { color1: '#9597D6', color2: '#33C9F3', gradient: 'linear-gradient(to bottom, #9597D6, #33C9F3)' },
    { color1: '#F9C014', color2: '#A962B2', gradient: 'linear-gradient(to bottom, #F9C014, #A962B2)' },
    { color1: '#EFD6EC', color2: '#5EDBFE', gradient: 'linear-gradient(to bottom, #EFD6EC, #5EDBFE)' },

    { color1: '#FF657E', color2: '#FFC40D', gradient: 'linear-gradient(to bottom, #FF657E, #FFC40D)' },
    { color1: '#5AD7FB', color2: '#F3698B', gradient: 'linear-gradient(to bottom, #5AD7FB, #F3698B)' },
    { color1: '#B6EC73', color2: '#F1CD1A', gradient: 'linear-gradient(to bottom, #B6EC73, #F1CD1A)' },
    { color1: '#E7D7C9', color2: '#E6BFAF', gradient: 'linear-gradient(to bottom, #E7D7C9, #E6BFAF)' },
    { color1: '#DD9790', color2: '#C3818D', gradient: 'linear-gradient(to bottom, #DD9790, #C3818D)' },
    { color1: '#D5ECDD', color2: '#F8D8F5', gradient: 'linear-gradient(to bottom, #D5ECDD, #F8D8F5)' },

    { color1: '#D2D0F5', color2: '#F8A9DA ', gradient: 'linear-gradient(to bottom, #D2D0F5, #F8A9DA)' },
    { color1: '#EFB7D5', color2: '#81DEF1', gradient: 'linear-gradient(to bottom, #EFB7D5, #81DEF1)' },
    { color1: '#F9D8F5', color2: '#FCDFD9', gradient: 'linear-gradient(to bottom, #F9D8F5, #FCDFD9)' },
    { color1: '#485296', color2: '#8F3481', gradient: 'linear-gradient(to bottom, #485296, #8F3481)' },
    { color1: '#49BCF6', color2: '#49DEB2', gradient: 'linear-gradient(140deg, #49BCF6, #49DEB2)' },
    { color1: '#D5EAF5', color2: '#F5DDDA', gradient: 'linear-gradient(to bottom, #D5EAF5, #F5DDDA)' },
  ],
];

export const backgroundImagesList = [
  `${BaseUrl}/content/background/1.jpg`,
  `${BaseUrl}/content/background/2.jpg`,
  `${BaseUrl}/content/background/3.jpg`,
  `${BaseUrl}/content/background/4.jpg`,
  `${BaseUrl}/content/background/5.jpg`,
  `${BaseUrl}/content/background/6.jpg`,
];

export const productsTypes = {
  custom: 'Custom',
  instagram: 'Instagram',
  shopify: 'Shopify',
  etsy: 'Etsy',
  spring: 'Spring',
};

export const sortShopTypes = [
  {
    title: 'Default sorting',
    sort: '',
    dir: '',
    type: 0,
    typeName: 'default',
  },
  {
    title: 'Date: Newest to Oldest',
    sort: 'date',
    dir: 'asc',
    type: 1,
    typeName: 'dateNew',
  },
  {
    title: 'Date: Oldest to Newest',
    sort: 'date',
    dir: 'desc',
    type: 2,
    typeName: 'dateOld',
  },
  {
    title: 'Price: Low to Hight',
    sort: 'price',
    dir: 'asc',
    type: 3,
    typeName: 'priceLow',
  },
  {
    title: 'Price: Hight to Low',
    sort: 'price',
    dir: 'desc',
    type: 4,
    typeName: 'priceHigh',
  },
  {
    title: 'Name: A to Z',
    sort: 'name',
    dir: 'asc',
    type: 5,
    typeName: 'nameA',
  },
  {
    title: 'Name: Z to A',
    sort: 'name',
    dir: 'desc',
    type: 6,
    typeName: 'nameZ',
  },
];

export const paymentList = [
  { id: crypto.randomUUID(), icon: IconPayPal, type: 'PayPal' },
  { id: crypto.randomUUID(), icon: IconStripe, type: 'Stripe' },
  { id: crypto.randomUUID(), icon: IconWayForPay, type: 'WayForPay' },
  { id: crypto.randomUUID(), icon: IconFondy, type: 'Fondy' },
];

export const blockList = [
  { id: crypto.randomUUID(), preview: IconShopPreview, icon: IconContentShop, type: sectionTypes.shop.type, title: sectionTypes.shop.title },
  { id: crypto.randomUUID(), preview: IconInstagramPreview, icon: IconContentDigital, type: sectionTypes.digital.type, title: sectionTypes.digital.title },
  { id: crypto.randomUUID(), preview: IconAppointmentPreview, icon: IconContentAppointment, type: sectionTypes.appointments.type, title: sectionTypes.appointments.title },
  { id: crypto.randomUUID(), preview: IconRequestPreview, icon: IconContentRequest, type: sectionTypes.requests.type, title: sectionTypes.requests.title },
  { id: crypto.randomUUID(), preview: IconTikTokPreview, icon: sectionTypes.events.icon, type: sectionTypes.events.type, title: sectionTypes.events.title },
  { id: crypto.randomUUID(), preview: IconCoursesPreview, icon: sectionTypes.courses.icon, type: sectionTypes.courses.type, title: sectionTypes.courses.title },
  { id: crypto.randomUUID(), preview: IconLinksPreview, icon: sectionTypes.links.icon, type: sectionTypes.links.type, title: sectionTypes.links.title },
  { id: crypto.randomUUID(), preview: IconDonationsPreview, icon: sectionTypes.donations.icon, type: sectionTypes.donations.type, title: sectionTypes.donations.title },
  { id: crypto.randomUUID(), preview: IconAppointmentPreview, icon: sectionTypes.membership.icon, type: sectionTypes.membership.type, title: sectionTypes.membership.title },
  { id: crypto.randomUUID(), preview: IconBlogPreview, icon: sectionTypes.blog.icon, type: sectionTypes.blog.type, title: sectionTypes.blog.title },
  { id: crypto.randomUUID(), preview: IconCouponsPreview, icon: sectionTypes.coupons.icon, type: sectionTypes.coupons.type, title: sectionTypes.coupons.title },
  { id: crypto.randomUUID(), preview: IconDonationsPreview, icon: sectionTypes.podcast.icon, type: sectionTypes.podcast.type, title: sectionTypes.podcast.title },
];

export const componentTypes = {
  accountSettings: 'accountSettings',
};

export const pageNavigationTypes = {
  top: 'top',
  bottom: 'bottom',
  hamburger: 'hamburger',
  tabs: 'tabs',
};

export const trackActionTypes = {
  clickLink: 1,
  clickProduct: 2,
  clickMessage: 3,
  clickSubscribe: 4,
  clickContact: 5, //redirect to messenger url
  clickSocialLink: 6,
  clickHighlighLink: 7,
  clickSliderLink: 8,
  clickTikTokShop: 9,
  clickYouTubeShop: 10,
  clickDonation: 11,
  clickAppointment: 12,
  clickRequest: 13,
  clickCoupon: 14,

  clickSplashButton: 15,
  clickPromobarButton: 16,
  clickHeaderButton: 17,
  clickCoverButton: 18,
  clickBannerButton: 19,
  clickTextButton: 20, //- - Bio, якщо є кнопка в біо
  clickPostButton: 21,
  clickInstagramTag: 22,
  clickTikTokTag: 23,
  clickYouTubeTag: 24,
  clickProductExtraButton: 25,
  clickProductDirectButton: 26,

  viewWallet: 27,
  viewFAQ: 28,
  viewContact: 29,
  viewTikTok: 30,
  viewYouTube: 31,

  addToCart: 32,
  submitShop: 33,
  submitShopPreorder: 34,
  submitEmail: 35,
  submitForm: 36,
  submitMessage: 37,
  submitDonation: 38,
  submitAppointment: 39,
  submitRequest: 40,
  submitDigital: 41,
  submitLink: 48,

  copiedWallet: 42,
  copiedCoupon: 43,
  clickEvents: 44,
  submitEvents: 45,
  clickCourses: 46,
  submitCourses: 47,
};

export const imagePrefix = {
  squareS: 'ss_',
  squareM: 'ms_',
  squareL: 'ls_',
  originalS: 'gs_',
  originalM: 'gm_',
  originalL: 'gl_',
};

export const positionTypes = {
  top: 'top',
  bottom: 'bottom',
};

export const viewProductList = [
  {
    id: crypto.randomUUID(),
    icon: IconCardView,
    title: 'Card',
    value: 'card',
  },
  {
    id: crypto.randomUUID(),
    icon: IconCompactView,
    title: 'Compact',
    value: 'compact',
  },
  {
    id: crypto.randomUUID(),
    icon: IconListView,
    title: 'List',
    value: 'list',
  },
];

export const viewPricingList = [
  {
    id: crypto.randomUUID(),
    icon: IconListView,
    title: 'List',
    value: 'list',
  },
  {
    id: crypto.randomUUID(),
    icon: IconCardView,
    title: 'Card',
    value: 'card',
  },
  {
    id: crypto.randomUUID(),
    icon: IconCompactView,
    title: 'Classic',
    value: 'classic',
  },
  {
    id: crypto.randomUUID(),
    icon: IconCardView,
    title: 'Service list',
    value: 'service-list',
  },
];

export const viewMembershipList = [
  {
    id: crypto.randomUUID(),
    icon: IconCardView,
    title: 'Card',
    value: 'card',
  },
  {
    id: crypto.randomUUID(),
    icon: IconListView,
    title: 'List',
    value: 'list',
  },
];

export const viewProductTypes = {
  card: 'card',
  compact: 'compact',
  list: 'list',
};

// Service block has its own 4-view set (adds a per-category slider). The view icons
// are inline SVG components (see Service/components/ServiceDesign/components/ServiceViewIcons)
// so their accent line recolours on the active view.
export const viewServiceTypes = {
  card: 'card',
  compact: 'compact',
  list: 'list',
  sliderCategory: 'slider-category',
};

export const viewEventsList = [
  {
    id: crypto.randomUUID(),
    icon: IconEventsSquareView,
    title: 'Square',
    value: 'squareEvents',
  },
  {
    id: crypto.randomUUID(),
    icon: IconEventsCardView,
    title: 'Card',
    value: 'card',
  },
  {
    id: crypto.randomUUID(),
    icon: IconEventsCompactView,
    title: 'Compact',
    value: 'ticket',
  },
];

export const walletTypes = {
  unilink: 'unilink',
  own: 'custom',
  money: 'money',
  defaultMerchantLogin: 'unilink_us',
};

export const viewCouponsList = [
  {
    id: crypto.randomUUID(),
    icon: IconEventsCardView,
    title: 'Card',
    value: 'card',
  },
  {
    id: crypto.randomUUID(),
    icon: IconEventsCompactView,
    title: 'Compact',
    value: 'compact',
  },
];

// export const templates = [
//   { id: 1, icon: IconThemeDefault },
//   { id: 2, icon: IconThemeEclipse },
//   { id: 3, icon: IconThemeKels },
//   { id: 4, icon: IconThemeMaterial },
//   { id: 5, icon: IconThemeSpotlight },
//   { id: 6, icon: IconThemeModerno },
//   { id: 7, icon: IconThemeNightview },
//   { id: 8, icon: IconThemeMinima },
//   { id: 9, icon: IconThemeStone },
//   { id: 10, icon: IconThemeTyla },
// ];

export const headerButtonTypes = {
  cta: 'cta',
  cart: 'cart',
  message: 'message',
  follow: 'follow',
  contact: 'contact',
};

export const confirmationActionTypes = {
  url: 'URL',
  message: 'Message',
  home: 'Home Page',
  none: '',
  view: 'View',
  redirect: 'URL Redirect',
  button: 'Text & Button',
  enlarge: 'Enlarge',
};

export const digitalActionTypes = [confirmationActionTypes.home, confirmationActionTypes.url, confirmationActionTypes.message];
export const instagramActionTypes = [confirmationActionTypes.enlarge, confirmationActionTypes.redirect, confirmationActionTypes.button];

export const aiTypesList = ['shorten', 'extend', 'official', 'witty', 'fix grammar', 'translate'];

export const emailStatusTypes = [
  {
    type: 'sent',
    color: '#CEEBCF',
    icon: <IconEditSent />,
  },
  {
    type: 'scheduled',
    color: '#F6E3D5',
    icon: <IconEditSheduled />,
  },
  {
    type: 'draft',
    color: '#E3E3E3',
    icon: <IconEditDraft />,
  },
  {
    type: 'failed',
    color: '#FFB2B2',
    icon: <IconEditFailed />,
  },
];

export const statusTypes = {
  avaliable: 'Available',
  soldout: 'Sold Out',
};

export const themesList = [
  {
    caption: 'Purple',
    value: 'purple',
    color: '#9b59b6',
  },
  {
    caption: 'Ice Cold',
    value: 'ice',
    color: '#b3f7ef',
  },
  {
    caption: 'Anti-flash',
    value: 'flash',
    color: '#f2f3f4',
  },
  {
    caption: 'Pale Pink',
    value: 'pale',
    color: '#f8d7e0',
  },
  {
    caption: 'Cameo Pink',
    value: 'cameo',
    color: '#f2b6d4',
  },
  {
    caption: 'Custom',
    color: 'conic-gradient(red, yellow, lime, aqua, blue, magenta, red)',
  },
];

export const websiteNavigationTabsTypes = {
  post: 'post',
  content: 'content',
  store: 'store',
};

export const PostAttachmentTypes = {
  image: 'image',
  video: 'video',
  audio: 'audio',
  article: 'article',
  product: 'product',
  attachment: 'attachment',
  map: 'map',
  link: 'link',
  cta: 'cta',
};
